// services/everpro/everpro-shipping/cache.ts - services/everpro/everpro-shipping.ts split (sub-module cache)

import type { EverproLogistic } from '../everpro-types';


export const everproLogisticsCache = {
  value: null as EverproLogistic[] | null,
  brandId: '' as string,
};
